import Request from './request'

const EsimProfile = {
  getEsimProfile(id, callback, bad_answer) {
    Request.get('simcard-profile-esim/index/' + id).then(callback).catch(bad_answer)
  },
  getPagesEsim (params, callback) {
    if (!params) {
      params = {}
    }
    Request.post('simcard-profile-esim/pages', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getEsimList (params, callback) {
    if (!params) {
      params = {}
    }
    Request.post('simcard-profile-esim/list/' + params.page, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getEsimGroups(callback) {
    Request.get('simcard-profile-esim/groups').then(callback).catch(this.bad_answer)
  },
  getEsimDevices (params, callback) {
    Request.post('simcard-profile-esim/status-info', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getEsimHistoryAction(params, callback) {
    Request.post('simcard-profile-esim/logs', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getEsimTariff(id, callback) {
    Request.get('simcard-profile-esim/tariff/'+ id).then(callback).catch(this.bad_answer)
  },
  getEsimTariffList(callback) {
    Request.get('simcard-profile-esim/mno-tariffs').then(callback).catch(this.bad_answer)
  },
  getEsimActions(id, callback) {
    Request.get('simcard-profile-esim/get-actions/'+ id).then(callback).catch(this.bad_answer)
  },
  getEsimActionsHistory(callback) {
    Request.get('simcard-profile-esim/actions-history').then(callback).catch(this.bad_answer)
  },
  runEsimActions(id, action, protocol, params, callback) {
    Request.post('simcard-profile-esim/run-action/'+ id +'?action='+action +'&protocol='+protocol, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  addEsim (params, callback, bad_answer) {
    Request.post('simcard-profile-esim/create', JSON.stringify(params)).then(callback).catch(bad_answer)
  },
  getEsimProfileHistory(id, callback) {
    Request.post('simcard-profile-esim/history/' + id).then(callback).catch(this.bad_answer)
  },
  setDevice (params, callback, bad_answer) {
    Request.post('simcard-profile-esim/set-device', JSON.stringify(params)).then(callback).catch(bad_answer)
  },
  resetDevice (id, params, callback, bad_answer) {
    Request.post('simcard-profile-esim/reset-device/' + id, JSON.stringify(params)).then(callback).catch(bad_answer)
  },
  setBlockedEsim (id, params, callback) {
    Request.post('simcard-profile-esim/set-blocked/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
}
export default EsimProfile
